import keyMirror from 'keymirror';

const types = keyMirror({
	REFRESH_SESSION: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/SessionConstants.js